import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown, Loader2, Info } from 'lucide-react';

// Top 100 S&P 500 stocks by market cap
const SP500_STOCKS = [
  { symbol: 'AAPL', name: 'Apple Inc.', sector: 'Technology', headquarters: 'California', marketCap: 3500, founded: 1976 },
  { symbol: 'MSFT', name: 'Microsoft Corporation', sector: 'Technology', headquarters: 'Washington', marketCap: 3200, founded: 1975 },
  { symbol: 'GOOGL', name: 'Alphabet Inc.', sector: 'Technology', headquarters: 'California', marketCap: 2100, founded: 1998 },
  { symbol: 'AMZN', name: 'Amazon.com Inc.', sector: 'Consumer Cyclical', headquarters: 'Washington', marketCap: 1900, founded: 1994 },
  { symbol: 'NVDA', name: 'NVIDIA Corporation', sector: 'Technology', headquarters: 'California', marketCap: 3300, founded: 1993 },
  { symbol: 'TSLA', name: 'Tesla Inc.', sector: 'Consumer Cyclical', headquarters: 'Texas', marketCap: 1100, founded: 2003 },
  { symbol: 'META', name: 'Meta Platforms Inc.', sector: 'Technology', headquarters: 'California', marketCap: 1300, founded: 2004 },
  { symbol: 'BRK.B', name: 'Berkshire Hathaway', sector: 'Financial', headquarters: 'Nebraska', marketCap: 1000, founded: 1839 },
  { symbol: 'JPM', name: 'JPMorgan Chase & Co.', sector: 'Financial', headquarters: 'New York', marketCap: 650, founded: 1799 },
  { symbol: 'V', name: 'Visa Inc.', sector: 'Financial', headquarters: 'California', marketCap: 620, founded: 1958 },
  { symbol: 'WMT', name: 'Walmart Inc.', sector: 'Consumer Defensive', headquarters: 'Arkansas', marketCap: 580, founded: 1962 },
  { symbol: 'JNJ', name: 'Johnson & Johnson', sector: 'Healthcare', headquarters: 'New Jersey', marketCap: 380, founded: 1886 },
  { symbol: 'PG', name: 'Procter & Gamble', sector: 'Consumer Defensive', headquarters: 'Ohio', marketCap: 420, founded: 1837 },
  { symbol: 'XOM', name: 'Exxon Mobil', sector: 'Energy', headquarters: 'Texas', marketCap: 480, founded: 1999 },
  { symbol: 'MA', name: 'Mastercard Inc.', sector: 'Financial', headquarters: 'New York', marketCap: 470, founded: 1966 },
  { symbol: 'DIS', name: 'Walt Disney Company', sector: 'Communication', headquarters: 'California', marketCap: 210, founded: 1923 },
  { symbol: 'NKE', name: 'Nike Inc.', sector: 'Consumer Cyclical', headquarters: 'Oregon', marketCap: 180, founded: 1964 },
  { symbol: 'KO', name: 'Coca-Cola Company', sector: 'Consumer Defensive', headquarters: 'Georgia', marketCap: 290, founded: 1892 },
  { symbol: 'MCD', name: 'McDonald\'s Corporation', sector: 'Consumer Cyclical', headquarters: 'Illinois', marketCap: 220, founded: 1940 },
  { symbol: 'BAC', name: 'Bank of America', sector: 'Financial', headquarters: 'North Carolina', marketCap: 340, founded: 1904 },
  { symbol: 'COST', name: 'Costco Wholesale', sector: 'Consumer Defensive', headquarters: 'Washington', marketCap: 380, founded: 1983 },
  { symbol: 'NFLX', name: 'Netflix Inc.', sector: 'Communication', headquarters: 'California', marketCap: 320, founded: 1997 },
  { symbol: 'INTC', name: 'Intel Corporation', sector: 'Technology', headquarters: 'California', marketCap: 180, founded: 1968 },
  { symbol: 'CSCO', name: 'Cisco Systems', sector: 'Technology', headquarters: 'California', marketCap: 220, founded: 1984 },
  { symbol: 'PEP', name: 'PepsiCo Inc.', sector: 'Consumer Defensive', headquarters: 'New York', marketCap: 250, founded: 1898 },
  { symbol: 'T', name: 'AT&T Inc.', sector: 'Communication', headquarters: 'Texas', marketCap: 120, founded: 1983 },
  { symbol: 'VZ', name: 'Verizon Communications', sector: 'Communication', headquarters: 'New York', marketCap: 180, founded: 1983 },
  { symbol: 'ADBE', name: 'Adobe Inc.', sector: 'Technology', headquarters: 'California', marketCap: 240, founded: 1982 },
  { symbol: 'CRM', name: 'Salesforce Inc.', sector: 'Technology', headquarters: 'California', marketCap: 280, founded: 1999 },
  { symbol: 'ORCL', name: 'Oracle Corporation', sector: 'Technology', headquarters: 'Texas', marketCap: 380, founded: 1977 },
  { symbol: 'ABT', name: 'Abbott Laboratories', sector: 'Healthcare', headquarters: 'Illinois', marketCap: 190, founded: 1888 },
  { symbol: 'CVX', name: 'Chevron Corporation', sector: 'Energy', headquarters: 'California', marketCap: 290, founded: 1879 },
  { symbol: 'LLY', name: 'Eli Lilly and Company', sector: 'Healthcare', headquarters: 'Indiana', marketCap: 750, founded: 1876 },
  { symbol: 'TMO', name: 'Thermo Fisher Scientific', sector: 'Healthcare', headquarters: 'Massachusetts', marketCap: 220, founded: 1956 },
  { symbol: 'ACN', name: 'Accenture plc', sector: 'Technology', headquarters: 'Ireland', marketCap: 210, founded: 1989 },
  { symbol: 'MRK', name: 'Merck & Co. Inc.', sector: 'Healthcare', headquarters: 'New Jersey', marketCap: 260, founded: 1891 },
  { symbol: 'ABBV', name: 'AbbVie Inc.', sector: 'Healthcare', headquarters: 'Illinois', marketCap: 310, founded: 2013 },
  { symbol: 'AMD', name: 'Advanced Micro Devices', sector: 'Technology', headquarters: 'California', marketCap: 220, founded: 1969 },
  { symbol: 'TXN', name: 'Texas Instruments', sector: 'Technology', headquarters: 'Texas', marketCap: 180, founded: 1930 },
  { symbol: 'AVGO', name: 'Broadcom Inc.', sector: 'Technology', headquarters: 'California', marketCap: 760, founded: 1961 },
  { symbol: 'WFC', name: 'Wells Fargo & Company', sector: 'Financial', headquarters: 'California', marketCap: 210, founded: 1852 },
  { symbol: 'BMY', name: 'Bristol-Myers Squibb', sector: 'Healthcare', headquarters: 'New York', marketCap: 110, founded: 1887 },
  { symbol: 'MS', name: 'Morgan Stanley', sector: 'Financial', headquarters: 'New York', marketCap: 180, founded: 1935 },
  { symbol: 'PM', name: 'Philip Morris International', sector: 'Consumer Defensive', headquarters: 'New York', marketCap: 170, founded: 2008 },
  { symbol: 'RTX', name: 'Raytheon Technologies', sector: 'Industrials', headquarters: 'Virginia', marketCap: 140, founded: 2020 },
  { symbol: 'HON', name: 'Honeywell International', sector: 'Industrials', headquarters: 'North Carolina', marketCap: 140, founded: 1906 },
  { symbol: 'UNP', name: 'Union Pacific Corporation', sector: 'Industrials', headquarters: 'Nebraska', marketCap: 150, founded: 1862 },
  { symbol: 'NEE', name: 'NextEra Energy', sector: 'Utilities', headquarters: 'Florida', marketCap: 150, founded: 1925 },
  { symbol: 'LOW', name: 'Lowe\'s Companies', sector: 'Consumer Cyclical', headquarters: 'North Carolina', marketCap: 140, founded: 1946 },
  { symbol: 'UPS', name: 'United Parcel Service', sector: 'Industrials', headquarters: 'Georgia', marketCap: 110, founded: 1907 },
  // Adding 50 more stocks to reach top 100
  { symbol: 'QCOM', name: 'Qualcomm Inc.', sector: 'Technology', headquarters: 'California', marketCap: 180, founded: 1985 },
  { symbol: 'GS', name: 'Goldman Sachs', sector: 'Financial', headquarters: 'New York', marketCap: 140, founded: 1869 },
  { symbol: 'CAT', name: 'Caterpillar Inc.', sector: 'Industrials', headquarters: 'Illinois', marketCap: 160, founded: 1925 },
  { symbol: 'DE', name: 'Deere & Company', sector: 'Industrials', headquarters: 'Illinois', marketCap: 110, founded: 1837 },
  { symbol: 'BA', name: 'Boeing Company', sector: 'Industrials', headquarters: 'Virginia', marketCap: 130, founded: 1916 },
  { symbol: 'IBM', name: 'IBM', sector: 'Technology', headquarters: 'New York', marketCap: 150, founded: 1911 },
  { symbol: 'GE', name: 'General Electric', sector: 'Industrials', headquarters: 'Massachusetts', marketCap: 140, founded: 1892 },
  { symbol: 'SPGI', name: 'S&P Global Inc.', sector: 'Financial', headquarters: 'New York', marketCap: 130, founded: 1888 },
  { symbol: 'AXP', name: 'American Express', sector: 'Financial', headquarters: 'New York', marketCap: 160, founded: 1850 },
  { symbol: 'BLK', name: 'BlackRock Inc.', sector: 'Financial', headquarters: 'New York', marketCap: 130, founded: 1988 },
  { symbol: 'NOW', name: 'ServiceNow Inc.', sector: 'Technology', headquarters: 'California', marketCap: 180, founded: 2004 },
  { symbol: 'INTU', name: 'Intuit Inc.', sector: 'Technology', headquarters: 'California', marketCap: 140, founded: 1983 },
  { symbol: 'ISRG', name: 'Intuitive Surgical', sector: 'Healthcare', headquarters: 'California', marketCap: 130, founded: 1995 },
  { symbol: 'TJX', name: 'TJX Companies', sector: 'Consumer Cyclical', headquarters: 'Massachusetts', marketCap: 110, founded: 1956 },
  { symbol: 'AMGN', name: 'Amgen Inc.', sector: 'Healthcare', headquarters: 'California', marketCap: 150, founded: 1980 },
  { symbol: 'HD', name: 'Home Depot', sector: 'Consumer Cyclical', headquarters: 'Georgia', marketCap: 380, founded: 1978 },
  { symbol: 'BKNG', name: 'Booking Holdings', sector: 'Consumer Cyclical', headquarters: 'Connecticut', marketCap: 140, founded: 1996 },
  { symbol: 'SBUX', name: 'Starbucks Corporation', sector: 'Consumer Cyclical', headquarters: 'Washington', marketCap: 100, founded: 1971 },
  { symbol: 'GILD', name: 'Gilead Sciences', sector: 'Healthcare', headquarters: 'California', marketCap: 100, founded: 1987 },
  { symbol: 'ADP', name: 'Automatic Data Processing', sector: 'Technology', headquarters: 'New Jersey', marketCap: 110, founded: 1949 },
  { symbol: 'MMC', name: 'Marsh & McLennan', sector: 'Financial', headquarters: 'New York', marketCap: 100, founded: 1871 },
  { symbol: 'CI', name: 'Cigna Corporation', sector: 'Healthcare', headquarters: 'Connecticut', marketCap: 100, founded: 1982 },
  { symbol: 'MDLZ', name: 'Mondelez International', sector: 'Consumer Defensive', headquarters: 'Illinois', marketCap: 90, founded: 2012 },
  { symbol: 'CVS', name: 'CVS Health Corporation', sector: 'Healthcare', headquarters: 'Rhode Island', marketCap: 75, founded: 1963 },
  { symbol: 'REGN', name: 'Regeneron Pharmaceuticals', sector: 'Healthcare', headquarters: 'New York', marketCap: 95, founded: 1988 },
  { symbol: 'TGT', name: 'Target Corporation', sector: 'Consumer Defensive', headquarters: 'Minnesota', marketCap: 65, founded: 1902 },
  { symbol: 'SO', name: 'Southern Company', sector: 'Utilities', headquarters: 'Georgia', marketCap: 90, founded: 1945 },
  { symbol: 'DUK', name: 'Duke Energy', sector: 'Utilities', headquarters: 'North Carolina', marketCap: 85, founded: 1904 },
  { symbol: 'USB', name: 'U.S. Bancorp', sector: 'Financial', headquarters: 'Minnesota', marketCap: 70, founded: 1863 },
  { symbol: 'PNC', name: 'PNC Financial Services', sector: 'Financial', headquarters: 'Pennsylvania', marketCap: 70, founded: 1845 },
  { symbol: 'C', name: 'Citigroup Inc.', sector: 'Financial', headquarters: 'New York', marketCap: 120, founded: 1812 },
  { symbol: 'SCHW', name: 'Charles Schwab Corporation', sector: 'Financial', headquarters: 'Texas', marketCap: 140, founded: 1971 },
  { symbol: 'CB', name: 'Chubb Limited', sector: 'Financial', headquarters: 'Switzerland', marketCap: 110, founded: 1882 },
  { symbol: 'PLD', name: 'Prologis Inc.', sector: 'Real Estate', headquarters: 'California', marketCap: 110, founded: 1983 },
  { symbol: 'AMT', name: 'American Tower Corporation', sector: 'Real Estate', headquarters: 'Massachusetts', marketCap: 95, founded: 1995 },
  { symbol: 'CCI', name: 'Crown Castle Inc.', sector: 'Real Estate', headquarters: 'Texas', marketCap: 70, founded: 1994 },
  { symbol: 'MO', name: 'Altria Group', sector: 'Consumer Defensive', headquarters: 'Virginia', marketCap: 90, founded: 1985 },
  { symbol: 'CL', name: 'Colgate-Palmolive', sector: 'Consumer Defensive', headquarters: 'New York', marketCap: 75, founded: 1806 },
  { symbol: 'LRCX', name: 'Lam Research', sector: 'Technology', headquarters: 'California', marketCap: 95, founded: 1980 },
  { symbol: 'AMAT', name: 'Applied Materials', sector: 'Technology', headquarters: 'California', marketCap: 130, founded: 1967 },
  { symbol: 'ADI', name: 'Analog Devices', sector: 'Technology', headquarters: 'Massachusetts', marketCap: 100, founded: 1965 },
  { symbol: 'PYPL', name: 'PayPal Holdings', sector: 'Financial', headquarters: 'California', marketCap: 75, founded: 1998 },
  { symbol: 'CME', name: 'CME Group', sector: 'Financial', headquarters: 'Illinois', marketCap: 80, founded: 1898 },
  { symbol: 'SYK', name: 'Stryker Corporation', sector: 'Healthcare', headquarters: 'Michigan', marketCap: 120, founded: 1941 },
  { symbol: 'ZTS', name: 'Zoetis Inc.', sector: 'Healthcare', headquarters: 'New Jersey', marketCap: 80, founded: 2013 },
  { symbol: 'BSX', name: 'Boston Scientific', sector: 'Healthcare', headquarters: 'Massachusetts', marketCap: 125, founded: 1979 },
  { symbol: 'MU', name: 'Micron Technology', sector: 'Technology', headquarters: 'Idaho', marketCap: 110, founded: 1978 },
  { symbol: 'PANW', name: 'Palo Alto Networks', sector: 'Technology', headquarters: 'California', marketCap: 110, founded: 2005 },
  { symbol: 'FI', name: 'Fiserv Inc.', sector: 'Financial', headquarters: 'Wisconsin', marketCap: 95, founded: 1984 }
];

export default function StockGuessingGame() {
  const [targetStock, setTargetStock] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [sp500Data, setSp500Data] = useState(null);
  const [timeframe, setTimeframe] = useState('1Y');
  const [guesses, setGuesses] = useState([]);
  const [currentGuess, setCurrentGuess] = useState('');
  const [gameOver, setGameOver] = useState(false);
  const [won, setWon] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = 'https://stock-wordle-backend.vercel.app/api/stock';

  const startNewGame = async () => {
    setLoading(true);
    setError(null);
    
    const randomStock = SP500_STOCKS[Math.floor(Math.random() * SP500_STOCKS.length)];
    setTargetStock(randomStock);
    setGuesses([]);
    setCurrentGuess('');
    setGameOver(false);
    setWon(false);
    setTimeframe('1Y');
    setSuggestions([]);
    
    try {
      const stockUrl = `${API_BASE_URL}?symbol=${randomStock.symbol}`;
      const sp500Url = `${API_BASE_URL}?symbol=SPY`;
      
      // Add timeout to fetch requests
      const fetchWithTimeout = (url, timeout = 15000) => {
        return Promise.race([
          fetch(url, {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
            },
            mode: 'cors'
          }),
          new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Request timeout after 15 seconds')), timeout)
          )
        ]);
      };
      
      const stockResponse = await fetchWithTimeout(stockUrl);
      
      if (!stockResponse.ok) {
        throw new Error(`HTTP ${stockResponse.status}: ${stockResponse.statusText}`);
      }
      
      const sp500Response = await fetchWithTimeout(sp500Url);
      
      if (!sp500Response.ok) {
        throw new Error(`HTTP ${sp500Response.status}: ${sp500Response.statusText}`);
      }
      
      const stockData = await stockResponse.json();
      const sp500Data = await sp500Response.json();
      
      if (stockData.error) {
        throw new Error(`Stock API error: ${stockData.error}`);
      }
      
      if (sp500Data.error) {
        throw new Error(`SP500 API error: ${sp500Data.error}`);
      }
      
      if (!stockData.data || !sp500Data.data) {
        throw new Error('Invalid data format: missing "data" field');
      }
      
      setChartData(stockData.data);
      setSp500Data(sp500Data.data);
      setLoading(false);
    } catch (err) {
      console.error('Error loading game:', err);
      
      // Provide more helpful error messages
      let userMessage = err.message;
      if (err.message.includes('Failed to fetch')) {
        userMessage = 'Network error: Unable to connect to the API.';
      } else if (err.message.includes('timeout')) {
        userMessage = 'Request timeout: The API took too long to respond.';
      }
      
      setError(userMessage);
      setLoading(false);
    }
  };

  useEffect(() => {
    startNewGame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setCurrentGuess(value);
    
    if (value.length > 0) {
      // Filter stocks that match the search
      const filtered = SP500_STOCKS.filter(s => 
        s.symbol.startsWith(value) || s.name.toUpperCase().includes(value)
      );
      
      // Sort: same sector first, then alphabetically
      const sorted = filtered.sort((a, b) => {
        const aSameSector = a.sector === targetStock.sector;
        const bSameSector = b.sector === targetStock.sector;
        
        if (aSameSector && !bSameSector) return -1;
        if (!aSameSector && bSameSector) return 1;
        return a.symbol.localeCompare(b.symbol);
      });
      
      setSuggestions(sorted); // Show ALL matching suggestions
    } else {
      // If empty input, show ALL stocks from the same sector
      const sameSector = SP500_STOCKS.filter(s => s.sector === targetStock.sector)
        .sort((a, b) => a.symbol.localeCompare(b.symbol));
      setSuggestions(sameSector); // Show ALL from same sector
    }
  };

  const makeGuess = (stock) => {
    if (guesses.length >= 6 || gameOver) return;
    
    const isCorrect = stock.symbol === targetStock.symbol;
    const hint = {
      stock,
      sameHeadquarters: stock.headquarters === targetStock.headquarters,
      marketCapDirection: stock.marketCap < targetStock.marketCap ? 'higher' : 
                          stock.marketCap > targetStock.marketCap ? 'lower' : 'same',
      foundedDirection: stock.founded < targetStock.founded ? 'newer' : 
                       stock.founded > targetStock.founded ? 'older' : 'same year'
    };
    
    const newGuesses = [...guesses, hint];
    setGuesses(newGuesses);
    setCurrentGuess('');
    setSuggestions([]);
    
    if (isCorrect) {
      setWon(true);
      setGameOver(true);
    } else if (newGuesses.length >= 6) {
      setGameOver(true);
    }
  };

  const renderChart = () => {
    if (!chartData || !sp500Data) return null;
    
    const data = chartData[timeframe];
    const sp500 = sp500Data[timeframe];
    
    if (!data || data.length === 0) return null;
    
    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min;
    
    const chartLeft = 15;
    const chartRight = 95;
    const chartTop = 10;
    const chartBottom = 85;
    const chartWidth = chartRight - chartLeft;
    const chartHeight = chartBottom - chartTop;
    
    const stockPoints = data.map((price, i) => {
      const x = chartLeft + (i / (data.length - 1)) * chartWidth;
      const y = chartTop + (1 - (price - min) / range) * chartHeight;
      return `${x},${y}`;
    }).join(' ');
    
    const change = ((data[data.length - 1] - data[0]) / data[0]) * 100;
    const sp500Change = ((sp500[sp500.length - 1] - sp500[0]) / sp500[0]) * 100;
    
    const yLabels = [max, (max + min) / 2, min].map((val, i) => ({
      value: val,
      y: chartTop + (i * chartHeight / 2)
    }));
    
    return (
      <div className="bg-white rounded-lg p-6 shadow-lg">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-4">
            <div>
              <h3 className="text-lg font-semibold">Mystery Stock Chart</h3>
              <p className="text-xs text-gray-500">Sector: {targetStock.sector} • All returns are split-adjusted</p>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                <span className={`text-sm font-medium ${change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  Stock: {change >= 0 ? '+' : ''}{change.toFixed(2)}%
                </span>
                {change >= 0 ? <TrendingUp size={16} className="text-green-600" /> : <TrendingDown size={16} className="text-red-600" />}
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-sm font-medium ${sp500Change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  S&P 500: {sp500Change >= 0 ? '+' : ''}{sp500Change.toFixed(2)}%
                </span>
                {sp500Change >= 0 ? <TrendingUp size={16} className="text-green-600" /> : <TrendingDown size={16} className="text-red-600" />}
              </div>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            {['3M', '1Y'].map(tf => (
              <button
                key={tf}
                onClick={() => setTimeframe(tf)}
                className={`px-3 py-1 rounded text-sm ${
                  timeframe === tf 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-200 hover:bg-gray-300'
                }`}
              >
                {tf}
              </button>
            ))}
            <div className="relative group">
              <Info size={18} className="text-gray-400 hover:text-gray-600 cursor-help" />
              <div className="absolute right-0 top-8 w-80 bg-gray-900 text-white text-xs rounded-lg p-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-20 shadow-lg">
                <p className="font-semibold mb-2">How to Play:</p>
                <ul className="space-y-1 list-disc list-inside">
                  <li>Guess the mystery stock in 6 tries</li>
                  <li>The sector is revealed as a clue</li>
                  <li>After each guess, you'll see hints:</li>
                  <ul className="ml-6 mt-1 space-y-0.5">
                    <li>🟢 Green = Match</li>
                    <li>🔴 Red = Different</li>
                    <li>🟡 Yellow = Higher/Lower</li>
                  </ul>
                  <li>Compare headquarters, market cap, and founding year</li>
                  <li>Use the chart patterns to help narrow down options</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <svg viewBox="0 0 100 100" className="w-full h-96 bg-gray-50 rounded">
          <line x1={chartLeft} y1={chartTop} x2={chartLeft} y2={chartBottom} stroke="#666" strokeWidth="0.3" />
          <line x1={chartLeft} y1={chartBottom} x2={chartRight} y2={chartBottom} stroke="#666" strokeWidth="0.3" />
          
          {yLabels.map((label, i) => (
            <text key={i} x={chartLeft - 2} y={label.y} fontSize="3" fill="#666" textAnchor="end" dominantBaseline="middle">
              ${label.value.toFixed(0)}
            </text>
          ))}
          
          <text x={chartLeft} y={chartBottom + 5} fontSize="3" fill="#666" textAnchor="start">Start</text>
          <text x={chartRight} y={chartBottom + 5} fontSize="3" fill="#666" textAnchor="end">Now</text>
          
          {yLabels.map((label, i) => (
            <line key={i} x1={chartLeft} y1={label.y} x2={chartRight} y2={label.y} stroke="#e5e7eb" strokeWidth="0.2" />
          ))}
          
          <polyline points={stockPoints} fill="none" stroke="#2563eb" strokeWidth="0.6" />
        </svg>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-6">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">Stock Chart Wordle</h1>
          <p className="text-gray-600">Guess the stock from its chart in 6 tries!</p>
          <p className="text-xs text-gray-500 mt-1">Using real historical stock data from Twelve Data API</p>
        </div>

        {loading && (
          <div className="bg-white rounded-lg p-12 shadow-lg text-center">
            <Loader2 className="animate-spin text-blue-600 mx-auto mb-4" size={48} />
            <p className="text-gray-600">Loading real stock data...</p>
          </div>
        )}

        {error && !loading && (
          <div className="bg-white rounded-lg p-8 shadow-lg text-center">
            <p className="text-red-600 mb-2 font-semibold text-lg">Error Loading Game</p>
            <p className="text-gray-700 mb-4">{error}</p>
            <button
              onClick={startNewGame}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700"
            >
              Try Again
            </button>
          </div>
        )}

        {!loading && !error && renderChart()}

        {!loading && !error && !gameOver && (
          <div className="mt-6 bg-white rounded-lg p-6 shadow-lg">
            <div className="flex gap-2 mb-4">
              <div className="flex-1 relative">
                <input
                  type="text"
                  value={currentGuess}
                  onChange={handleInputChange}
                  onFocus={handleInputChange}
                  placeholder="Type stock symbol or name (or click to see sector stocks)..."
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                  disabled={gameOver}
                />
                {suggestions.length > 0 && (
                  <div className="absolute w-full bg-white border-2 border-gray-300 rounded-lg mt-1 shadow-lg z-10 max-h-64 overflow-y-auto">
                    {suggestions.map(stock => {
                      const sameSector = stock.sector === targetStock.sector;
                      return (
                        <button
                          key={stock.symbol}
                          onClick={() => makeGuess(stock)}
                          className={`w-full px-4 py-2 text-left hover:bg-blue-50 flex justify-between items-center ${
                            sameSector ? 'bg-green-50' : ''
                          }`}
                        >
                          <div className="flex items-center gap-2">
                            <span className="font-semibold">{stock.symbol}</span>
                            {sameSector && <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">Same sector</span>}
                          </div>
                          <span className="text-sm text-gray-600">{stock.name}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-sm text-gray-600">Guesses remaining: {6 - guesses.length}</p>
              <button
                onClick={() => {
                  if (window.confirm('Are you sure you want to reveal the answer and end the game?')) {
                    setGameOver(true);
                    setWon(false);
                  }
                }}
                className="px-4 py-2 border-2 border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 font-medium text-sm transition-colors"
              >
                Reveal Answer
              </button>
            </div>
          </div>
        )}

        {!loading && !error && guesses.length > 0 && (
          <div className="mt-6 bg-white rounded-lg p-6 shadow-lg overflow-x-auto">
            <h3 className="text-lg font-semibold mb-4">Your Guesses</h3>
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b-2 border-gray-300">
                  <th className="text-left p-3 font-semibold">Guess</th>
                  <th className="text-left p-3 font-semibold">Headquarters</th>
                  <th className="text-left p-3 font-semibold">Market Cap</th>
                  <th className="text-left p-3 font-semibold">Year Founded</th>
                </tr>
              </thead>
              <tbody>
                {guesses.map((guess, i) => (
                  <tr key={i} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-3">
                      <div className="font-semibold">{guess.stock.symbol}</div>
                      <div className="text-sm text-gray-600">{guess.stock.name}</div>
                    </td>
                    <td className="p-3">
                      <div className={`inline-flex items-center gap-1 px-3 py-1 rounded ${
                        guess.sameHeadquarters ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {guess.sameHeadquarters ? '✓ Same' : '✗ Different'}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">{guess.stock.headquarters}</div>
                    </td>
                    <td className="p-3">
                      <div className={`inline-flex items-center gap-1 px-3 py-1 rounded ${
                        guess.marketCapDirection === 'same' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {guess.marketCapDirection === 'same' ? '✓ Same' : 
                         guess.marketCapDirection === 'higher' ? '↑ Higher' : '↓ Lower'}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">${guess.stock.marketCap}B</div>
                    </td>
                    <td className="p-3">
                      <div className={`inline-flex items-center gap-1 px-3 py-1 rounded ${
                        guess.foundedDirection === 'same year' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {guess.foundedDirection === 'same year' ? '✓ Same' : 
                         guess.foundedDirection === 'newer' ? '📅 Newer' : '📜 Older'}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">{guess.stock.founded}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && !error && gameOver && (
          <div className="mt-6 bg-white rounded-lg p-6 shadow-lg text-center">
            {won ? (
              <>
                <h2 className="text-3xl font-bold text-green-600 mb-2">🎉 Correct!</h2>
                <p className="text-xl mb-4">You guessed {targetStock.symbol} in {guesses.length} {guesses.length === 1 ? 'try' : 'tries'}!</p>
              </>
            ) : (
              <>
                <h2 className="text-3xl font-bold text-red-600 mb-2">
                  {guesses.length === 0 ? 'Answer Revealed!' : 'Game Over!'}
                </h2>
                <p className="text-xl mb-2">The stock was <span className="font-bold">{targetStock.symbol}</span> - {targetStock.name}</p>
                <div className="mt-4 bg-gray-50 rounded-lg p-4 text-left inline-block">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Answer:</p>
                  <div className="space-y-1 text-sm text-gray-600">
                    <p><span className="font-medium">Headquarters:</span> {targetStock.headquarters}</p>
                    <p><span className="font-medium">Market Cap:</span> ${targetStock.marketCap}B</p>
                    <p><span className="font-medium">Founded:</span> {targetStock.founded}</p>
                  </div>
                </div>
              </>
            )}
            <button
              onClick={startNewGame}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 mt-4"
            >
              Play Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
